var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-div',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('admin-header-navigation'),_c('DaReportPage',{attrs:{"isReadOnly":false,"user_type":"adm"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }